module.exports = `${require.publicPath}sby-logo.f7615310.webp`;